module.exports = __webpack_public_path__ + "img/logo-sd-hp.0a49a93a.png";